import MenuActionTypes from './menu-types';

export const updateListaEstados = (estados) => ({
  type: MenuActionTypes.UPDATE_LISTA_ESTADOS,
  payload: estados
});

export const updateEstado = (estado) => ({
  type: MenuActionTypes.UPDATE_ESTADO,
  payload: estado
});

export const updateListaProcesos = (idEstado, procesos) => ({
  type: MenuActionTypes.UPDATE_LISTA_PROCESOS,
  payload: {
    idEstado,
    procesos
  }
});

export const updateDetalle = (detalle) => ({
  type: MenuActionTypes.UPDATE_DETALLE,
  payload: detalle
});

export const updateListaDistritos = (idDetalle, idEstado, distritos) => ({
  type: MenuActionTypes.UPDATE_LISTA_DISTRITOS,
  payload: {
    idDetalle, 
    idEstado,
    distritos
  }
});

export const updateDistrito = (distrito) => ({
  type: MenuActionTypes.UPDATE_DISTRITO,
  payload: distrito
});

export const updateRutaPublicador = (idEstado, idDetalle, rutaPublicador) => ({
  type: MenuActionTypes.UPDATE_RUTA_PUBLICADOR,
  payload: {
    idEstado,
    idDetalle,
    rutaPublicador
  }
});